// src/components/Auth/Redirector.js

import React, { useEffect } from "react";
import { useAuthRedirect } from "../../hooks/useAuthRedirect";

const PROJECT_KEY = "ijrr_user";

/**
 * Redirector
 * * Checks if a user is already authenticated.
 * If found, it redirects them "inside" the app (Dashboard/Profiler) using the unified logic.
 * If not found, it renders the children (Public/Guest pages).
 * * @param {ReactNode} children - the element to render if no redirect
 */
export default function Redirector({ children }) {
  const { redirectAuthenticatedUser } = useAuthRedirect();

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem(PROJECT_KEY));

    if (user) {
      redirectAuthenticatedUser(user);
    }
  }, [redirectAuthenticatedUser]);

  return <>{children}</>;
}